import { defineStore } from 'pinia';
import api from '@/services/api';

export const usePuestoStore = defineStore('puestoStore', {
  state: () => ({
    puestoList: [],
    page: 1,
  }),
  actions: {
    async findAllPuestoHTTP() {
      const result = await api.get('/puesto', { params: { page: +this.page } });
      if (result && result.data) {
        this.puestoList.splice(0, this.puestoList.length, ...result.data);
        this.setPage(this.page + 1);
        return true;
      }
      return false;
    },

    async firstPuesto() {
      this.setPage(1);
      this.emptyList();
      await this.findAllPuestoHTTP();
    },
    setPage(page) {
      this.page = page;
    },
    emptyList() {
      this.puestoList = [];
    },
  },
});
